import { render, staticRenderFns } from "./WeeklyBudgetChartMemory.vue?vue&type=template&id=260a37e8"
var script = {}
import style0 from "./WeeklyBudgetChartMemory.vue?vue&type=style&index=0&id=260a37e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports